import { render } from "./MessagesPage.vue?vue&type=template&id=84c7bd6a&scoped=true"
import script from "./MessagesPage.vue?vue&type=script&lang=js"
export * from "./MessagesPage.vue?vue&type=script&lang=js"

import "./MessagesPage.vue?vue&type=style&index=0&id=84c7bd6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c7bd6a"]])

export default __exports__